// extracted by mini-css-extract-plugin
module.exports = {"formView":"FormView_formView","formViewForm":"FormView_formViewForm"};